const days = [
    'zo',
    'ma',
    'di',
    'wo',
    'do',
    'vr',
    'za'
];
const months = [
    'januari',
    'februari',
    'maart',
    'april',
    'mei',
    'juni',
    'juli',
    'augustus',
    'september',
    'oktober',
    'november',
    'december'
];
export const nl = {
    code: 'nl',
    localize: {
        ordinalNumber: (n)=>`${n}e`,
        era: (n)=>n === 0 ? 'v.Chr.' : 'n.Chr.',
        quarter: (n)=>`${n}e kwartaal`,
        month: (n)=>months[n],
        day: (n)=>days[n],
        dayPeriod: (n)=>n === 'am' ? 'AM' : 'PM'
    },
    formatLong: {
        date: ()=>'dd-MM-yyyy',
        time: ()=>'HH:mm',
        dateTime: ()=>'dd-MM-yyyy HH:mm'
    },
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
